import { get } from 'lodash';
import { call, put, take, fork, select } from 'redux-saga/effects';
import { delay } from 'redux-saga';

import { INIT_APP_ERROR } from '@/redux/ducks/init/types';
import {
	REPORT_LIST_REQUESTING,
	REPORT_LIST_SUCCESS,
	REPORT_LIST_ERROR,
	GENERATING_REPORT_ERROR,
	GENERATING_REPORT_REQUESTING,
	GENERATING_REPORT_SUCCESS,
} from '@/redux/ducks/report/types';
import { SHOW_TOAST } from '@/redux/ducks/toast/types';
import { getObjValue } from '@/utils/helper';
import Api from '@/data';
import {
	selectChimeraConfig,
	selectMerchantType,
} from '@/redux/ducks/merchantProfile/selectors';
import Constants from '@/utils/constants';

const { ONLINE_MERCHANT } = Constants;

export const getReportFilters = (state) => state.reportList.filters;

// Function to fecth report list
export function* fetchReportList(payload) {
	try {
		yield put({
			type: REPORT_LIST_REQUESTING,
			payload,
		});
		const merchantType = yield select(selectMerchantType);
		const chimeraConfigData = yield select(selectChimeraConfig);
		// NOTE: Changing the api call function here as Reports page is not revamped and based on configs
		const isOnlineMerchant =
			merchantType === ONLINE_MERCHANT &&
			!chimeraConfigData.ONLINE_MX_VIA_MIGS_ENABLED;
		const reportListApiCall = isOnlineMerchant
			? Api.omReportList
			: Api.reportList;

		const response = yield call(reportListApiCall, payload);
		yield put({
			type: REPORT_LIST_SUCCESS,
			data: getObjValue(response, 'data'),
		});
		// check if status is equal to PROCESSING then call API again
		while (response.data[0].state === 'PROCESSING') {
			yield put({
				type: REPORT_LIST_REQUESTING,
				payload,
			});
			const secondResponse = yield call(reportListApiCall, payload);
			yield put({
				type: REPORT_LIST_SUCCESS,
				data: getObjValue(secondResponse, 'data'),
			});
			yield call(delay, 30000);
			response.data[0].state = secondResponse.data[0].state;
		}
	} catch (error) {
		if (error.status === 401) {
			yield put({ type: INIT_APP_ERROR, error: error.data });
		} else {
			yield put({ type: REPORT_LIST_ERROR, error: error.data });
		}
	}
}

export function* getReportListWatcher() {
	while (true) {
		const payload = yield take(REPORT_LIST_REQUESTING);
		yield call(fetchReportList, payload.payload);
	}
}

// Function to generate report
export function* generateReport(payload) {
	try {
		yield put({
			type: GENERATING_REPORT_REQUESTING,
			payload,
		});
		const merchantType = yield select(selectMerchantType);

		// NOTE: Changing the api call function here as Reports page is not revamped and based on configs
		const generateReportApiCall =
			merchantType === ONLINE_MERCHANT
				? Api.omGenerateReport
				: Api.generateReport;

		const response = yield call(generateReportApiCall, payload);
		yield put({
			type: GENERATING_REPORT_SUCCESS,
			data: response.data,
		});
		// yield put({
		//   type: SHOW_TOAST,
		//   payload: {
		//     msg: 'Report generation in progress. Please wait…',
		//     type: 'info',
		//   },
		// });
		// calling refund report list again to refresh
		const reportListFilter = yield select(getReportFilters);
		yield put({
			type: REPORT_LIST_REQUESTING,
			payload: reportListFilter,
		});
	} catch (error) {
		if (error.status === 401) {
			yield put({ type: INIT_APP_ERROR, error: error.data });
		} else {
			yield put({ type: GENERATING_REPORT_ERROR, error: error.data });
			yield put({
				type: SHOW_TOAST,
				payload: { msg: get(error, 'data.message'), type: 'error' },
			});
		}
	}
}

export function* generateRefundReportWatcher() {
	while (true) {
		const { payload } = yield take(GENERATING_REPORT_REQUESTING);
		yield call(generateReport, payload);
	}
}

function* manageReportSaga() {
	yield fork(getReportListWatcher);
	yield fork(generateRefundReportWatcher);
}

export default manageReportSaga;
